function animateScroll() {
  window.scroll({ top: 0, left: 0, behavior: "smooth" });
}

function toEventFormat(_data) {
  return {
    id: _data?.eventId ?? _data?.EventId,
    name: _data?.eventName ?? _data?.EventName,
    location: _data?.location ?? _data?.Location,
    image: _data?.imagepath ?? _data?.Image,
    category: _data?.categoryName ?? _data?.CategoryName,
    rating: _data?.ratings ?? _data?.Ratings,
    isTrending: _data?.IsTrending,
    timeId: _data?.timeId ?? _data.TimeId,
    startDate: _data?.startDate ?? _data?.StartDate,
    isVirtual: _data?.IsVirtual,
    images: _data?.photos ?? _data?.ImageUrls ?? null,
    distance: _data?.nearMe ?? _data?.DistanceMile,
    startTime: _data?.startTime ?? _data?.StartTime,
    isNew: _data?.isNewEvent ?? _data?.IsNewEvent,
    advertisment: _data?.Advertisement ?? null,
  };
}

function toAdFormat(_data) {
  return {
    name: _data?.eventName ?? _data.Name,
    image: _data?.imagepath ?? _data.ImagePath,
    url: _data?.ticketUrl ?? _data?.Url,
  };
}

export { animateScroll, toEventFormat, toAdFormat };
